import { render } from "./InstanceListRow.vue?vue&type=template&id=06a1730c&scoped=true&ts=true"
import script from "./InstanceListRow.vue?vue&type=script&lang=ts"
export * from "./InstanceListRow.vue?vue&type=script&lang=ts"

import "./InstanceListRow.vue?vue&type=style&index=0&id=06a1730c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a1730c"]])

export default __exports__